import { useState } from "react";

import DepartmentsDropdownCard from "../departments/DepartmentsDropdownCard";
import PrioritiesTable from "./PrioritiesTable";
import { LS_SELECTED_DEPARTMENT_ID } from "../../common/utils/common";

export default function PrioritiesPage() {
  const [selectedDepartmentId, setSelectedDepartmentId] = useState(localStorage.getItem(LS_SELECTED_DEPARTMENT_ID) || "");

  return (
    <div className="flex flex-column gap-2">
      <DepartmentsDropdownCard
        showAll
        value={selectedDepartmentId}
        onChange={(department) => setSelectedDepartmentId(department)}
      ></DepartmentsDropdownCard>
      <PrioritiesTable departmentId={selectedDepartmentId}></PrioritiesTable>
    </div>
  );
}
